import { deleteListOffer } from 'pages/candidateOfferList';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusScreen } from 'shared/components';
import { APP_ROUTES } from 'shared/constants';
import { useAppDispatch, useNavigateWithSearch } from 'shared/hooks';

import { useOfferRouteParams } from '../hooks';

function OfferNotFound() {
    const dispatch = useAppDispatch();
    const { t } = useTranslation('candidateOffers');
    const navigate = useNavigateWithSearch();
    const { orderId, orderRoleId } = useOfferRouteParams();

    const handleOpenMainPage = useCallback(() => {
        dispatch(deleteListOffer({ orderId, orderRoleId }));
        navigate(APP_ROUTES.candidateOffers);
    }, [ navigate, orderId, orderRoleId, dispatch ]);

    return (
        <StatusScreen variant="info"
            title={ t('errorPage.notFound.title') }
            description={ t('errorPage.notFound.description') }
            buttonProps={{
                label: t('errorActions.openMainPage'),
                onClick: handleOpenMainPage,
                color: 'primary',
                size: 'medium'
            }}
        />
    );
}

export default memo(OfferNotFound);
